import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Model } from 'survey-core';
import { VariablesService } from '../survey/variables.service';

interface CivicDataResponse {
  normalizedInput: {
    line1: string;
    city: string;
    state: string;
    zip: string;
  };
  divisions: {
    [key: string]: {
      name: string;
    };
  };
}

@Injectable({
  providedIn: 'root'
})
export class CivicDataUtilsService {

  constructor(
    private http: HttpClient, 
    private variablesService: VariablesService
  ) {}

  getCivicData(address: string, model: Model) {
    if (!address) {
      console.log('No address available');
      return;
    }
    const civicApiKey = this.variablesService.getVariable('civic_api_key')
    const encodedAddress = encodeURIComponent(address);
    const url = `https://www.googleapis.com/civicinfo/v2/representatives?key=${civicApiKey}&address=${encodedAddress}`;

    return this.http.get<CivicDataResponse>(url).pipe(
      map(data => this.processCivicInfo(data, model))
    );
  }

  private processCivicInfo(civicData: CivicDataResponse, model: Model): void {
    const { normalizedInput, divisions } = civicData;
    let civicInfo = `Address: ${normalizedInput.line1} ${normalizedInput.city}, ${normalizedInput.state} ${normalizedInput.zip}\n\n`;

    Object.values(divisions).forEach(division => {
      civicInfo += `${division.name}\n`;
    });

    model.setValue('CivicInformation', civicInfo);    
  }
}








